import React from 'react';
import { findByText } from 'Common/Utils';
import { IntroNotice } from './IntroNotice';
import { ClickGesture } from 'Snippets/Redundancy';

export const CustomizeMessages = [
	{
		message: <IntroNotice message={2} />,
		find: 'a[data-chaperone-trigger]',
	},
	{
		message: (
			<>
				Firstly, I wanna show you how to use <b>formSate</b> in single
				fetchingly...
			</>
		),
		find(target) {
			return findByText(target, 'span:formState')[1];
		},
	},
	{
		message: (
			<>
				And Secondly, before we go back to the topic. I wanna show you how to
				use field state property <b>isValidated</b>. it will be fixed{' '}
				<b>true</b> if ever the user touched the form field, and it will be{' '}
				<b>false</b> again once the form is <b>reseted</b>...
			</>
		),
		find(target) {
			return findByText(target, 'span:isValidated')[0];
		},
	},
	{
		message: (
			<>
				Let'z back to the topic. as you can observe on first and second demo.
				Each rules has it's own <b>message model pattern</b> which is provided
				when the specific rule has failed and it will be found in field state{' '}
				property <b>message</b>...
			</>
		),
		find(target) {
			return findByText(target, 'span:required')[0];
		},
	},
	{
		message: (
			<>
				If ever you want to make your own messages on some specific rules, you
				can always use field state property <b>failedIn</b> that will bring you
				which rule has been failing. so you can make a simple statement to work
				around it. like below...
			</>
		),
		onNext() {
			localStorage.getItem('f-cmes') || localStorage.setItem('f-cmes', 1);
		},
		find(target) {
			return findByText(target, 'span:failedIn')[0];
		},
	},
	{
		message: <>That was quick! Let's try out the result!</>,
		find: '.code-result textarea',
		isDoneOnClick: true,
		gesture: <ClickGesture />,
		background: {
			backdropStyle: { opacity: 1 },
			highlightStyle: { backgroundColor: 'rgba(255,255,255, 1)' },
		},
	},
];
